import React from "react"
import { graphql } from "gatsby"
import { Container, Heading } from "@theme-ui/components"
import Layout from "../components/layout"
import { getHomePath } from "../utils/path"
import { HelmetDatoCms } from "gatsby-source-datocms"
import { Box } from "theme-ui"
import MultipleTitle from "../components/multipleTitle"
import IntroVideo from "../components/IntroVideo"
import HomeSolutionCollection from "../components/homeSolutionCollection"
import HomeListCollection from "../components/homeListCollection"
import BigTitle from "../components/bigTitle"
import HomeVideoCard from "../components/homeVideoCard"
import ProjectCollection from "../components/projectCollection"
import CtaCollection from "../components/ctaCollection"

const Home = ({
  data: { page, site, footer, menu, partner, contactPage },
  pageContext,
}) => {
  console.log(contactPage)
  const locale = pageContext.locale
  console.log(page)
  const i18nPaths = site.locales.map(locale => {
    return {
      locale: locale,
      value: getHomePath(locale),
    }
  })

  return (
    <Layout
      locale={locale}
      i18nPaths={i18nPaths}
      footerData={footer.nodes}
      menuData={menu.nodes}
      partner={partner}
    >
      <HelmetDatoCms seo={page.seoMetaTags}>
        <html lang={locale} />
      </HelmetDatoCms>

      <Box as="section" sx={{}}>
        {page.content.map(block => (
          <Box sx={{}}>
            {block.model.apiKey === "multiple_title" && (
              <MultipleTitle block={block} />
            )}
            {block.model.apiKey === "intro_video" && (
              <IntroVideo
                block={block}
                contactPage={contactPage}
                media={block.video}
              />
            )}
            {block.model.apiKey === "home_solution_collection" && (
              <HomeSolutionCollection block={block} />
            )}
            {block.model.apiKey === "list_collection" && (
              <HomeListCollection block={block} />
            )}
            {block.model.apiKey === "big_title_and_link" && (
              <BigTitle block={block} />
            )}
            {block.model.apiKey === "home_video_card" && (
              <HomeVideoCard block={block} media={block.video} />
            )}
            {block.model.apiKey === "project_collection" && (
              <ProjectCollection block={block} />
            )}
            {block.model.apiKey === "cta_collection" && (
              <CtaCollection block={block} />
            )}
          </Box>
        ))}
      </Box>
    </Layout>
  )
}

export default Home

export const query = graphql`
  query HomeQuery($locale: String!) {
    page: datoCmsHomePage(locale: $locale) {
      id
      title
      locales
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      content {
        ... on DatoCmsCtaCollection {
          id
          cta {
            title
            subtitle
            link {
              anchor
              link {
                ... on DatoCmsPage {
                  root
                  id
                  _allSlugLocales {
                    locale
                    value
                  }
                }
              }
            }
          }
          model {
            apiKey
          }
        }
        ... on DatoCmsMultipleTitle {
          id
          model {
            apiKey
          }
          title1
          title2
          links {
            anchor
            link {
              ... on DatoCmsPage {
                root
                id
                _allSlugLocales {
                  locale
                  value
                }
              }
            }
          }
        }
        ... on DatoCmsIntroVideo {
          id
          model {
            apiKey
          }
          columnLeft
          columnRight
          video {
            alt
            title
            mimeType
            blurhash
            customData
            video {
              streamingUrl
              thumbnailUrl(format: jpg)
              mp4Url(exactRes: low)
              muxPlaybackId
            }
            gatsbyImageData(width: 1920, placeholder: BLURRED)
          }
        }
        ... on DatoCmsHomeSolutionCollection {
          id
          model {
            apiKey
          }
          kicker
          title
          subtitle
          cards {
            image {
              url
            }
            blackImage {
              url
            }
            page {
              ... on DatoCmsInternalLink {
                id
                anchor
                link {
                  ... on DatoCmsPage {
                    id
                    root
                    _allSlugLocales {
                      locale
                      value
                    }
                  }
                }
              }
            }
            title
            subtitle
            body
            background {
              hex
            }

            image {
              url
              title
            }
          }
        }
        ... on DatoCmsListCollection {
          id
          model {
            apiKey
          }
          list
          title
          dark
          kicker

          model {
            apiKey
          }
        }
        ... on DatoCmsBigTitleAndLink {
          id
          model {
            apiKey
          }
          title
          kicker
          contact
          link {
            anchor
            link {
              ... on DatoCmsPage {
                root
                id
                _allSlugLocales {
                  locale
                  value
                }
              }
            }
          }
        }
        ... on DatoCmsHomeVideoCard {
          id
          model {
            apiKey
          }
          video {
            alt
            title
            mimeType
            blurhash
            customData
            video {
              streamingUrl
              thumbnailUrl(format: jpg)
              mp4Url(exactRes: low)
              muxPlaybackId
            }
            gatsbyImageData(width: 1920, placeholder: BLURRED)
          }
          body
        }
        ... on DatoCmsProjectCollection {
          id
          model {
            apiKey
          }
          kicker
          title
          link {
            anchor
            link {
              ... on DatoCmsPage {
                id
                root
                _allSlugLocales {
                  value
                  locale
                }
                slug
              }
            }
          }
          projects {
            title
            slug
            _allSlugLocales {
              locale
              value
            }
            image {
              gatsbyImageData(width: 800, placeholder: BLURRED)
            }
            imageThumb {
              gatsbyImageData
              url
            }
          }
        }
      }
    }
    partner: allDatoCmsPartner(sort: { position: ASC }) {
      ...PartnerFragment
    }
    site: datoCmsSite {
      locales
    }

    menu: allDatoCmsMenu(
      locale: $locale
      filter: { root: { eq: true }, locales: { eq: $locale } }
      sort: { position: ASC }
    ) {
      nodes {
        ...MenuDetails
      }
    }
    contactPage: datoCmsPage(id: { eq: "DatoCmsPage-68744702" }) {
      slug
      title
      root
      _allSlugLocales {
        locale
        value
      }
    }
    footer: allDatoCmsFooter(
      locale: $locale
      filter: { root: { eq: true }, locales: { eq: $locale } }
      sort: { position: ASC }
    ) {
      nodes {
        ...FooterDetails
      }
    }
  }

  fragment PartnerFragment on DatoCmsPartnerConnection {
    nodes {
      position
      title
      image {
        url
      }
      imageBlack {
        url
      }
    }
  }
  fragment MenuDetails on DatoCmsMenu {
    id
    locales
    root
    anchor
    link {
      ... on DatoCmsInternalLink {
        id
        anchor
        locales
        model {
          apiKey
        }
        link {
          ... on DatoCmsProductCategory {
            id
            locales
            title
            slug
            _allSlugLocales {
              value
              locale
            }
            model {
              apiKey
            }
          }
          ... on DatoCmsProduct {
            ...ProductPageDetails
            ...AllProductSlugLocales
          }
          ... on DatoCmsBlogPage {
            ...BlogDetails
          }
          ... on DatoCmsPage {
            id
            locales
            title
            slug
            root
            model {
              apiKey
            }
            ...PageTreeParent
            ...AllSlugLocales
          }
          ... on DatoCmsArticle {
            id
            locales
            title
            slug
            model {
              apiKey
            }
            category {
              title
              slug
              ...ArticleCategoryAllSlugLocales
            }
            ...ArticleAllSlugLocales
          }
          ... on DatoCmsArticleCategory {
            ...ArticleCategoryDetails
            ...ArticleCategoryAllSlugLocales
          }
        }
      }
      ... on DatoCmsExternalLink {
        id
        anchor
        url
        model {
          apiKey
        }
      }
    }
    treeChildren {
      id
      locales
      root
      anchor
      link {
        ... on DatoCmsInternalLink {
          id
          anchor
          locales
          model {
            apiKey
          }
          link {
            ... on DatoCmsProductCategory {
              id
              locales
              title
              slug

              _allSlugLocales {
                value
                locale
              }
              model {
                apiKey
              }
            }
            ... on DatoCmsProduct {
              ...ProductPageDetails
              ...AllProductSlugLocales
            }
            ... on DatoCmsBlogPage {
              ...BlogDetails
            }
            ... on DatoCmsPage {
              id
              locales
              title
              slug
              root
              model {
                apiKey
              }
              ...PageTreeParent
              ...AllSlugLocales
            }
            ... on DatoCmsArticle {
              id
              locales
              title
              slug
              model {
                apiKey
              }
              category {
                title
                slug
                ...ArticleCategoryAllSlugLocales
              }
              ...ArticleAllSlugLocales
            }
            ... on DatoCmsArticleCategory {
              ...ArticleCategoryDetails
              ...ArticleCategoryAllSlugLocales
            }
          }
        }
        ... on DatoCmsExternalLink {
          id
          anchor
          url
          model {
            apiKey
          }
        }
      }
      treeChildren {
        id
        locales
        root
        anchor
        link {
          ... on DatoCmsInternalLink {
            id
            anchor
            locales
            model {
              apiKey
            }
            link {
              ... on DatoCmsProductCategory {
                id
                locales
                title
                slug

                _allSlugLocales {
                  value
                  locale
                }
                model {
                  apiKey
                }
              }
              ... on DatoCmsProduct {
                ...ProductPageDetails
                ...AllProductSlugLocales
              }
              ... on DatoCmsBlogPage {
                ...BlogDetails
              }
              ... on DatoCmsPage {
                id
                locales
                title
                slug
                root
                model {
                  apiKey
                }
                ...PageTreeParent
                ...AllSlugLocales
              }
              ... on DatoCmsArticle {
                id
                locales
                title
                slug
                model {
                  apiKey
                }
                category {
                  title
                  slug
                  ...ArticleCategoryAllSlugLocales
                }
                ...ArticleAllSlugLocales
              }
              ... on DatoCmsArticleCategory {
                ...ArticleCategoryDetails
                ...ArticleCategoryAllSlugLocales
              }
            }
          }
          ... on DatoCmsExternalLink {
            id
            anchor
            url
            model {
              apiKey
            }
          }
        }
      }
    }
  }

  fragment FooterDetails on DatoCmsFooter {
    id
    root
    anchor
    position
    link {
      ... on DatoCmsInternalLink {
        id
        anchor
        model {
          apiKey
        }
        ...InternalLinkPages
      }
      ... on DatoCmsExternalLink {
        id
        anchor
        url
        model {
          apiKey
        }
      }
    }
    treeChildren {
      id
      root
      anchor
      position
      link {
        ... on DatoCmsInternalLink {
          id
          anchor

          model {
            apiKey
          }
          ...InternalLinkPages
        }
        ... on DatoCmsExternalLink {
          id
          anchor
          url
          model {
            apiKey
          }
        }
      }
      treeChildren {
        id
        root
        anchor
        position
        link {
          ... on DatoCmsInternalLink {
            id
            anchor

            model {
              apiKey
            }
            ...InternalLinkPages
          }
          ... on DatoCmsExternalLink {
            id
            anchor
            url
            model {
              apiKey
            }
          }
        }
      }
    }
  }

  fragment InternalLinkPages on DatoCmsInternalLink {
    link {
      ... on DatoCmsProductCategory {
        ...ProductCategoryPageDetails
      }
      ... on DatoCmsProduct {
        ...ProductPageDetails
        ...AllProductSlugLocales
      }
      ... on DatoCmsBlogPage {
        ...BlogDetails
      }
      ... on DatoCmsPage {
        ...PageDetails
        ...PageTreeParent
        ...AllSlugLocales
      }
      ... on DatoCmsArticle {
        ...ArticleDetails
        ...ArticleAllSlugLocales
      }
      ... on DatoCmsArticleCategory {
        ...ArticleCategoryDetails
        ...ArticleCategoryAllSlugLocales
      }
    }
  }
`
